<template>
  <div class="main-content">
    <section class="section">
      <!-- Breadcrumb -->
      <PageHeaderNoAction :page="this">
        <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="far fa-save mr-2"></i>
              {{$helper.getWord('save')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>
              {{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-body">
            <h2>{{$helper.getWord('normal logo')}}:</h2>
            <FileUpload
              :isDirectLink="true"
              :multiple="false"
              accepts=".jpg, .jpeg, .png"
              ref="fileupload"
              v-model="files"
              :isedit="true"
              saveLink="/system_maintainence/mt11_file_save"
              :maxFiles="1"
            />
            <h2>{{$helper.getWord('small logo')}}:</h2>
            <FileUpload
              :isDirectLink="true"
              :multiple="false"
              accepts=".jpg, .jpeg, .png"
              ref="smallfileupload"
              v-model="smallFiles"
              :isedit="true"
              saveLink="/system_maintainence/mt11_file_save"
              :maxFiles="1"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";

export default {
  title: helper.getWord('company logo'),
  access_code: "G_MT11",
  icon: "far fa-copy fa-fw",
  components: {},
  order: 5,
  data() {
    return {
      formData: {},
      files: [],
      smallFiles: []
    };
  },
  created() {
    this.loadForm();
  },
  computed: {
    grid() {}
  },
  mounted() {},
  methods: {
    loadForm() {
      helper.loading();
      api.request(
        this,
        "post",
        "/system_maintainence/mt11_file_load",
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {}
        },
        function(r) {
          this.files = r.data.files || [];
          this.smallFiles = r.data.smallFiles || [];
          helper.done();
        },
        function(r) {
          helper.done();
        },
        null
      );
    },
    async saveButtonClicked() {
      let fileParams = [] , smallParams = [];
      this.files.forEach(f=>{
        fileParams.push(f);
      })
       this.smallFiles.forEach(f=>{
        smallParams.push(f);
      })
      await this.$refs.fileupload.save({
        id:"companyLogoImage",
        fileParams: fileParams
      });
      await this.$refs.smallfileupload.save({
        id: "companySmallLogoImage",
        fileParams: smallParams
      });

      // helper.clearData(this);
      // this.loadForm();
        this.$router.go(0);
    },
    cancelBtnClick() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>